<template>
  <section>
    <div class="card panel-white"
         v-if="serviceRequest.is_confirmed === 0 && serviceRequest.service_request_status_id === 3 && serviceRequest.offered_service_date">
      <div class="card-body">
        <h3>{{ $t('message.service_request.service_request_confirm_title') }}</h3>
        <div class="row no-gutters">
          <div class="col-6">{{ $t('message.service_request.service_cost') }}</div>
          <div class="col-6 text-right">
            <strong>{{ serviceRequest.service_cost | currency }}</strong>
          </div>
        </div>
        <div class="row no-gutters mt-2" v-if="serviceRequest.promotion_cost">
          <div class="col-6">{{ $t('message.service_request.promotion_cost') }}</div>
          <div class="col-6 text-right">
            <strong>{{ serviceRequest.promotion_cost | currency }}</strong>
          </div>
        </div>
        <div class="row no-gutters mt-2">
          <div class="col-6">{{ $t('message.service_request.service_request_offered_service_date') }}</div>
          <div class="col-6 text-right -status-new">
            {{ serviceRequest.offered_service_date | prettyDate }}
          </div>
        </div>
        <div class="row no-gutters mt-2" v-if="serviceRequest.duration_remark">
          <div class="col-8">{{ $t('message.service_request.service_request_duration_remark') }}</div>
          <div class="col-4 text-right">
            {{ serviceRequest.duration_remark }}
          </div>
        </div>
        <div class="row no-gutters mt-2" v-if="serviceRequest.offered_remark">
          <div class="col-12">
            <div class="text-remark">{{ $t('message.service_request.remark') }}</div>
            <div class="mt-2">{{ serviceRequest.offered_remark }}</div>
          </div>
        </div>
        <hr>
        <div class="pb-3">
          <span v-if="!serviceRequest.promotion_cost">{{ $t('message.service_request.service_request_confirm_expiration_remark') }}</span>
          <span v-else>{{ $t('message.service_request.service_request_confirm_expiration_remark2') }}</span>
        </div>
        <div class="row no-gutters">
          <div class="col-6 pr-2">
            <button
              @click.prevent="openModal()"
              class="btn btn-block btn-outline-info">
              {{ $t('message.service_request.service_request_button_decline') }}
            </button>
          </div>
          <div class="col-6 pl-2">
            <button
              @click.prevent="displayConfirmDialog('confirm')"
              class="btn btn-block btn-info">
              {{ $t('message.service_request.service_request_button_accept') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="showModal"
             @ok="declineServiceRequest"
             :ok-disabled="isLoading">
      <div slot="modal-title">
        {{ $i18n.t('message.service_request.service_request_dialog_decline_message') }}
      </div>
      <section>
        <div>
          <h4>{{ $i18n.t('message.service_request.cancel_remark') }}</h4>
          <div v-if="serviceRequestLostSalesReasons">
            <div class="radio" v-for="lostSalesReason in serviceRequestLostSalesReasons">
              <label>
                <input type="radio"
                       name="lostSalesReason"
                       :value="lostSalesReason"
                       v-model="selectedLostSalesReason"> {{ lostSalesReason | multiLangName }}
              </label>
            </div>
            <div v-if="selectedLostSalesReason && selectedLostSalesReason.is_other">
              <input type="text" class="form-control" :placeholder="$i18n.t('message.service_request.your_decline_reason')" v-model="declineRemark">
            </div>
          </div>
          <div class="text-danger pt-2" v-if="hasError">
            <i class="fas fa-exclamation-triangle"></i> {{ errorMessage }}
          </div>
        </div>
      </section>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="showModal = false">
          {{ $t('message.button.cancel') }}
        </b-button>
        <b-button variant="info" @click="ok()" :disabled="isLoading">
          {{ isLoading ? $t('message.button.loading') : $t('message.button.submit') }}
        </b-button>
      </template>
    </b-modal>
  </section>
</template>

<script>
  import axios from 'axios'

  export default {
    props: {
      serviceRequest: Object,
      serviceRequestLostSalesReasons: Array
    },
    data () {
      return {
        errorMessage: null,
        hasError: false,
        showModal: false,
        selectedLostSalesReason: null,
        isLoading: false,
        declineRemark: null
      }
    },
    watch: {
      selectedLostSalesReason () {
        if (this.selectedLostSalesReason) {
          this.errorMessage = null
          this.hasError = false
          this.declineRemark = null
        }
      }
    },
    methods: {
      openModal () {
        this.errorMessage = null
        this.hasError = false
        this.selectedLostSalesReason = null
        this.declineRemark = null
        this.isLoading = false
        this.showModal = true
      },
      displayConfirmDialog (action) {
        let textMessage = this.$i18n.t('message.service_request.service_request_dialog_confirm_message')
        let params = {
          is_confirmed: 1,
          actual_service_date: this.serviceRequest.offered_service_date
        }
        // Set decline case
        if (action === 'decline') {
          textMessage = this.$i18n.t('message.service_request.service_request_dialog_decline_message')
          params = {
            service_request_status_id: 4
          }
        }

        this.$swal({
          text: textMessage,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.confirm.yes'),
          cancelButtonText: this.$i18n.t('message.confirm.no')
        }).then(async () => {
          let {data} = await axios.put('/service-requests/' + this.serviceRequest.id, params)
          if (!data.error) {
            this.$emit('confirmDialogAction', true)
          } else {
            this.$swal({text: data.message, type: 'error'})
          }
        })
      },
      async declineServiceRequest (evt) {
        // Prevent modal from closing
        evt.preventDefault()
        this.hasError = false
        if (this.selectedLostSalesReason) {
          // Check other choice
          if (this.selectedLostSalesReason.is_other === 1 && !this.declineRemark) {
            this.hasError = true
            this.errorMessage = this.$i18n.t('message.required_field')
            return
          }
          this.isLoading = true
          const params = {
            service_request_status_id: 4,
            service_request_lost_sales_reason_id: this.selectedLostSalesReason.id,
            service_request_lost_sales_reason_remark: this.declineRemark
          }
          let {data} = await axios.put('/service-requests/' + this.serviceRequest.id, params)
          this.isLoading = false
          this.showModal = false
          if (!data.error) {
            this.$emit('confirmDialogAction', true)
          } else {
            this.$swal({text: data.message, type: 'error'})
          }
        } else {
          this.hasError = true
          this.errorMessage = this.$i18n.t('message.required_selection')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/serviceRequest/Components/ConfirmOfferSection.vue